import React from 'react';
import { StyledErrorLabel } from './styled';

type Props = {
	text: string;
} & React.InputHTMLAttributes<HTMLLabelElement>;

export default function ErrorLabel({ text, ...labelProps }: Props) {
	return <StyledErrorLabel {...labelProps}>{text}</StyledErrorLabel>;
}
